import { useTranslation } from "react-i18next";
import CustomTable, {
  IColumn,
} from "../../../../../common/CustomTable/CustomTable";
import { useAppSelector } from "../../../../../store/hooks";
import { RootState } from "../../../../../store/store";
import { currencyFormat } from "../../../../../utils/Utility";

const AdditionalDeductibles = () => {
  const { coveragesAndDiscounts } = useAppSelector(
    (state: RootState) => state.policyDetails
  );

  const { t } = useTranslation();

  const columns: IColumn[] = [
    { label: t("Perils"), accessorKey: "additonalDeductible" },
    { label: t("Deductible"), accessorKey: "value" },
  ];

  const getLablesOfDeductibles = (key: string) => {
    switch (key) {
      case "allPerilDed":
        return t("All Perils");
      case "windHailDed":
        return t("Wind/Hail");
    }
  };

  const dataArray = coveragesAndDiscounts
    ? Object.entries(coveragesAndDiscounts.additionalDeductibles).map(
        ([key, value]) => ({
          additonalDeductible: getLablesOfDeductibles(key),

          value: `${currencyFormat("us", value)}`,
        })
      )
    : [];
  return <CustomTable columns={columns} data={dataArray} />;
};

export default AdditionalDeductibles;
